import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { ConfirmationNumberOutlined } from '@mui/icons-material'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
import { useIntl } from 'react-intl'

interface MenuBookingCodesProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuBookingCodes = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuBookingCodesProps) => {
  const { formatMessage } = useIntl()
  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href="/live-chat/booking-codes"
        selected={pathname.startsWith('/live-chat/booking-codes')}
      >
        <ListItemIcon>
          <ConfirmationNumberOutlined />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({
            id: 'liveChat.sidebar.bookingCodes',
          })}
        />
      </MenuItem>
    </div>
  )
}
